export default __webpack_public_path__ + "static/source-separation-systems-australian-flora-foundation-30438ea8164f59f1651b9cda48b3318d.svg";